import { Box, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { Pill, Text } from "@src/appV2/redesign/system/ui-components";

import goldTrophyImage from "./assets/images/goldTrophy.png";
import {
  NURSES_WEEK_BANNER_GRADIENT,
  NURSES_WEEK_PILL_BACKGROUND,
  NURSES_WEEK_PILL_TEXT,
  NURSES_WEEK_TEXT_COLOR,
} from "./constants";

interface NursesWeekNominationBannerProps {
  onClick: () => void;
}

export function NursesWeekNominationBanner(props: NursesWeekNominationBannerProps) {
  const { onClick } = props;

  return (
    <Box sx={{ position: "relative" }}>
      <Stack
        sx={(theme) => ({
          padding: theme.spacing(5),
          borderRadius: theme.borderRadius?.medium,
          background: NURSES_WEEK_BANNER_GRADIENT,
          height: "100%",
          position: "relative",
          overflow: "hidden",
        })}
      >
        <Box
          aria-hidden
          alt=""
          component="img"
          src={goldTrophyImage}
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            height: "92%",
            maxHeight: 180,
            aspectRatio: "1 / 1",
            objectFit: "contain",
            pointerEvents: "none",
            transform: "translate(20%, 15%) rotate(18.48deg)",
          }}
        />
        <Stack gap={5} sx={{ flex: 1, justifyContent: "space-between", position: "relative" }}>
          <Stack gap={3}>
            <Text bold variant="h4" sx={{ color: NURSES_WEEK_TEXT_COLOR }}>
              Nurses Week Nomination
            </Text>
            <Pill
              label="Open through April 25th"
              size="small"
              backgroundColor={() => NURSES_WEEK_PILL_BACKGROUND}
              color={() => NURSES_WEEK_PILL_TEXT}
              sx={{ alignSelf: "flex-start" }}
            />
            <Text variant="body2" sx={{ color: NURSES_WEEK_TEXT_COLOR, maxWidth: "60%" }}>
              We are collecting real stories of excellent Nurses. Selected Nurses will be celebrated
              with gifts and recognition!
            </Text>
          </Stack>
          <Button
            size="small"
            sx={{ alignSelf: "flex-start" }}
            variant="contained"
            onClick={onClick}
          >
            Learn more
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
